module.exports = __webpack_public_path__ + "static/media/SolutionsImg_3.e4479580.jpg";